// import Vue from 'vue';
import axios from 'axios';
import axiosRetry from 'axios-retry';

declare const window;

const messages = {
  'EXPIRED_TOKEN': 'Lejárt token.',
  'UNDEFINED_TOKEN': 'A kérésben nincs token.',
  'INVALID_TOKEN': 'Érvénytelen token.',
  'INACTIVE_TOKEN': 'Inaktív token.'
};
const translate = (key: string) => messages[key];

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 3000,
	headers: { 'Cache-Control': 'no-cache' }
});

axiosRetry(http, {
  retries: 3,
  retryCondition: (error) => {
    return (
      error.code !== 'ECONNABORTED' &&
      (!error.response || (error.response.status === 401) || (error.response.status >= 500 && error.response.status <= 599))
    );
  }
});

http.interceptors.request.use(
  (config) => {
    return config;
  }, (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    if (response.headers['session-token']) {
      window.vue.$cookies.set('sessionToken', response.headers['session-token']);
      window.vue.$cookies.set('sessionExpiration', response.headers['session-expiration']);
    }
    return response.data;
  },
  async (error) => {
    if (!error.response) {
      if (window.vue.$dialogs.error) {
        window.vue.$dialogs.error.close();
        window.vue.$dialogs.error = false;
      }
      window.vue.$dialogs.error = await window.vue.$dialog.error({
        text: error,
        title: 'Hiba!',
        actions: ['Bezárás'],
        waitForResult: false
      });
      return Promise.reject(error);
    }
    const message: string = error.response.data.message || 'Ismeretlen hiba történt';
    if (message === 'EXPIRED_TOKEN' || message === 'UNDEFINED_TOKEN' || message === 'INVALID_TOKEN' || message === 'INACTIVE_TOKEN') {
      window.vue.$logout('Kérjük jelentkezzen be újra!');
      return Promise.reject(error);
    }
    if (window.vue.$dialogs.error) {
      window.vue.$dialogs.error.close();
      window.vue.$dialogs.error = false;
    }
    window.vue.$dialogs.error = await window.vue.$dialog.error({
      text: translate(message) || message,
      title: 'Hibaüzenet a szervertől!',
      actions: ['Bezárás'],
      waitForResult: false
    });
    return Promise.reject(error);
  }
);

export default http;
